import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSManager
 */
var BSSManager = /** @class */ (function () {
    /**
     *
     * @param {object} config configuration object
     * @param {object} toolbox - provides common libraries: jquery and lodash
     * @param {EventManager} eventManager instance of _EventManager
     */
    function BSSManager(config, toolbox, eventManager) {
        /**
         * @desc debug Mode
         * @type {boolean}
         * @private
         */
        logger.info('BSSManager => constructor | Params: ', config, toolbox, logger, eventManager);
        /**
         * @desc configuration Object
         * @type {object}
         * @private
         */
        this._config = config;
        /**
         * @desc toolbox provides common libraries: $ -jquery, _ - lodash
         * @type {Object}
         * @private
         */
        this._toolbox = toolbox;
        /**
         * @desc _EventManager
         * @type {Object}
         */
        this._eventManager = eventManager;
        /**
         * @private
         * @desc {string} name of drivers
         */
    }
    /**
     * @desc unsubscribe all the events of the component and remove element from DOM
     */
    BSSManager.prototype.destroy = function () {
        logger.info('BSSManager:  => function : destroy');
    };
    return BSSManager;
}());
export { BSSManager };
export default BSSManager;
